var _hmt = _hmt || [];
(function() {
  function isMobile() {
    return navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|miniprogram)/i
    );
  }
  if (!isMobile()) {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?59f0c75ecbc9c7ef2ba6d3c6eb1c548e";
    var s = document.getElementsByTagName("script")[0];
    console.log(s.parentNode);
    s.parentNode.insertBefore(hm, s);
    /**
     * 增加样式 20190624 wenyu
     */
    hm.setAttribute('style','z-index:2000;');
    s.setAttribute('style','z-index:2000;');
  }
  
})();



//////////////////
// WEBPACK FOOTER
// ./static/service.js
// module id = b2t7
// module chunks = 44